import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { ACMEValidator } from '@b2b/common/services/validate';
import { TODO } from '@b2b/types/core/utils';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IQService, IScope, ITimeoutService } from 'angular';
import { Partner, PartnerCompany } from '../types';

PartnersEditController.$inject = [
  '$scope',
  '$state',
  '$q',
  '$filter',
  '$uibModal',
  '$timeout',
  'ApiService',
  'ValidateService',
  'HelpersService',
  'NoticeFactory',
  'CategoriesData',
  'GridStateFactory',
  'GridDefinitionFactory',
];

function PartnersEditController(
  $scope: IScope & { partnersEdit: TODO },
  $state: StateService,
  $q: IQService,
  $filter: IFilterService,
  $uibModal: TODO,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  ValidateService: TODO,
  HelpersService: TODO,
  NoticeFactory: NoticeFactory,
  CategoriesData: TODO,
  GridStateFactory: TODO,
  GridDefinitionFactory: TODO,
) {
  const ctrl = {
    pageType: 'Create',
    isEditEnabled: false,
    submitText: 'Create',
    organizationId: '',

    isSubmitting: false,
    isSubmitted: false,
    model: {} as Partner,

    company: {} as Partial<PartnerCompany>,

    payment: {
      id: '',
      type: 'fullPayment',
      accountId: '',
      uniqueVoucherNumbers: false,
      ticketDelivery: 'print',
      taxExempt: false,
      balanceDueDays: 0,
      depositDueDays: 0,
      depositMinimumAmount: 0,
      depositMinimumPercent: 0,
    },

    secondaryContacts: [] as TODO[],

    removedSecondaryContacts: [] as TODO[],

    gridState: new GridStateFactory(),

    // viewId: $state.current.name,
    secondaryContactsGridName: $state.current.name + '.grid0',
    secondaryContactsGridState: new GridStateFactory(),
    secondaryContactsGridDefinition: new GridDefinitionFactory(),

    secondaryContactsOptionsOverride: {
      paginationPageSize: 25,
      rowHeight: 40,
      useAccessibleGrid: true,
      data: 'partnersEdit.secondaryContacts',
      columnDefs: [
        {
          field: 'edit',
          displayName: 'Edit',
          cellTemplate:
            '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row.entity)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.firstName }}{{ row.entity.lastName }}</span></a></div>',
          width: 60,
        },
        {
          field: 'id',
          displayName: 'ID',
          visible: false,
        },
        {
          field: 'firstName',
          displayName: 'First Name',
        },
        {
          field: 'lastName',
          displayName: 'Last Name',
        },
        {
          field: 'email',
          displayName: 'Email',
        },
        {
          field: 'phoneNumber',
          displayName: 'Phone Number',
        },
        {
          field: 'streetAddress1',
          displayName: 'Address 1',
        },
        {
          field: 'streetAddress2',
          displayName: 'Address 2',
        },
        {
          field: 'city',
          displayName: 'City',
        },
        {
          field: 'state',
          displayName: 'State',
        },
        {
          field: 'country',
          displayName: 'Country',
        },
        {
          field: 'zipCode',
          displayName: 'Zip Code',
        },
        {
          field: 'remove',
          displayName: '',
          cellTemplate:
            '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>',
          width: 80,
        },
      ],
      appScopeProvider: {
        onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
          ctrl.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
        },
        onDataGridSortChange: function (grid, columns, page) {
          ctrl.onDataGridSortChange(grid, columns, page);
        },
        onDblClick: function (row) {
          ctrl.editSecondaryContact(row);
        },
        remove: function (row) {
          ctrl.removeSecondaryContact(row);
        },
      },
    },

    notes: '',

    notice: new NoticeFactory(),

    savedPayment: {} as TODO,
    selectedCategory: {} as TODO,

    categories: [] as TODO[],

    viewId: $state.current.name,

    loadPreferences: $state.current.data.enablePreferences,

    primaryContactAddress: false,

    addModal: null as TODO,
    removeModal: null as TODO,
    editModal: null as TODO,
    changeAddressModal: null as TODO,
    editAddressModal: null as TODO,

    init: function () {
      let titleText = 'Create Organization';

      if ($state.params.hasOwnProperty('accountId')) {
        ctrl.pageType = 'Edit';
        ctrl.isEditEnabled = true;
        ctrl.submitText = 'Update';
        titleText = 'Edit Organization';
      }

      $scope.$emit('Application::contentTitleChange', {
        title: titleText,
        buttonLeft: {
          label: 'Cancel',
          action: function () {
            ctrl.cancel();
          },
        },
        buttonRight: {
          label: ctrl.submitText,
          action: function () {
            ctrl.complete();
          },
        },
      });

      if ($state.params.accountId) {
        ctrl.organizationId = $state.params.accountId;
      }

      if (CategoriesData.data && CategoriesData.data.success) {
        ctrl.success.getCategories(CategoriesData);
      } else {
        ctrl.error.getCategories(CategoriesData);
      }

      if (ctrl.isEditEnabled) {
        ctrl.getAccount();
        ctrl.getAccountPayment();
        ctrl.getAccountContacts($state.params.accountId);
      }

      ctrl.secondaryContactsGridDefinition.init(
        ctrl.secondaryContactsGridName,
        ctrl.secondaryContactsOptionsOverride,
        ctrl.viewId,
        $state.current.data.enablePreferences,
      );

      $scope.$on('AddressList::Create', ctrl.onAddressListCreate);
      $scope.$on('AddressList::Edit', ctrl.onAddressListEdit);
      $scope.$on('AddressList::PrimaryAddress', ctrl.onAddressListPrimaryAddress);
      $scope.$on('AddressDetail::Change', ctrl.onAddressDetailChange);
      $scope.$on('AddressDetail::Edit', ctrl.onAddressDetailEdit);
    },

    getAccount: function () {
      ctrl.getOrganization().then(ctrl.success.init, ctrl.error.init);
    },

    getOrganization: function () {
      const accountId = $state.params.accountId;
      return ApiService.partners.detail(accountId);
    },

    refreshOrganization: function () {
      ctrl.getOrganization().then((response) => {
        ctrl.company = response.data.payload.company || ctrl.model.company;
      });
    },

    getAccountPayment: function () {
      const accountId = $state.params.accountId;
      ApiService.partners.payments
        .account(accountId)
        .then(ctrl.success.getAccountPayment, ctrl.error.getAccountPayment);
    },

    getAccountContacts: function (accountId) {
      ApiService.organizations.contacts
        .list($.extend({ organizationId: accountId }, ctrl.secondaryContactsGridState.getGridState()))
        .then(ctrl.success.getAccountContacts, ctrl.error.getAccountContacts);
    },

    isValidCategory: function () {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ctrl.selectedCategory && ctrl.selectedCategory.hasOwnProperty('id');
      }

      return r;
    },

    isValidCompany: function (field) {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([
          {
            len: {
              value: ctrl.model.company[field],
            },
          },
        ] as ACMEValidator[]);
      }

      return r;
    },

    isValidContactFirst: function (prop) {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([
          {
            len: {
              value: prop,
            },
          },
          {
            name: prop,
          },
        ] as ACMEValidator[]);
      }

      return r;
    },

    isValidContactLast: function (prop) {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([
          {
            len: {
              value: prop,
            },
          },
          {
            name: prop,
          },
        ] as ACMEValidator[]);
      }

      return r;
    },

    isValidPhone: function (prop) {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([
          {
            phone: prop,
          },
        ] as ACMEValidator[]);
      }

      return r;
    },

    isValidEmail: function (email) {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([{ email: email }] as ACMEValidator[]);
      }

      return r;
    },

    filterContacts: function (contacts: TODO, primary: boolean) {
      const filtered = [] as TODO[];

      for (let i = 0, ii = contacts.length; i < ii; i++) {
        if (contacts[i].primary === primary) {
          filtered.push(contacts[i]);
        }
      }

      return filtered;
    },

    findContact: function (contacts: TODO, id: string | number) {
      const r = {
        index: -1,
        contact: null as TODO,
      };

      for (let i = 0, ii = contacts.length; i < ii; i++) {
        if (contacts[i].id === id) {
          r.contact = contacts[i];
          r.index = i;
          break;
        }
      }
      return r;
    },

    addSecondaryContact: function () {
      ctrl.addModal = $uibModal.open({
        templateUrl: 'views/application/views/partners/create/modals/ManageSecondaryContactModal.tpl.html',
        size: 'lg',
        controller: 'ManageSecondaryContactModalController',
        resolve: {
          ValidateService: function () {
            return ValidateService;
          },
          alertMessage: function () {
            return null;
          },
          organizationId: function () {
            return $state.params.accountId;
          },
          organizationName: function () {
            return $state.params.accountName;
          },
          contact: function () {
            return null;
          },
          address: function () {
            return null;
          },
        },
      });

      ctrl.addModal.result.then(
        function (contact) {
          //add the secondaryContact
          if (contact) {
            //add the index property to manage this contact locally (not stored on server yet)
            contact.index = ctrl.secondaryContacts.length;
          }
          ctrl.secondaryContacts.push(contact);
          ctrl.refreshOrganization();
          ctrl.refreshSecondaryContactList();
        },
        function () {
          //do nothing
        },
      );
    },

    removeSecondaryContact: function (row) {
      let index = -1;
      //first see if this is an existing contact.
      if (row.entity.id) {
        index = ctrl.findContact(ctrl.secondaryContacts, row.entity.id).index;
      } else if (row.entity.index !== undefined) {
        index = row.entity.index;
      }
      if (index > -1) {
        ctrl.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/partners/create/modals/RemoveSecondaryContactModal.tpl.html',
          size: 'lg',
          controller: 'RemoveSecondaryContactModalController',
          resolve: {
            ValidateService: function () {
              return ValidateService;
            },
            contact: function () {
              return ctrl.secondaryContacts[index];
            },
          },
        });

        ctrl.removeModal.result.then(
          function () {
            //remove the secondaryContact
            if (row.entity.id) {
              //remove later when page is saved
              ctrl.removedSecondaryContacts.push(ctrl.secondaryContacts.splice(index, 1)[0]);
            } else {
              ctrl.secondaryContacts.splice(index, 1);
            }
            ctrl.refreshSecondaryContactList();
          },
          function () {
            //do nothing
          },
        );
      }
    },

    editSecondaryContact: function (item) {
      let index = -1;
      if (item.id) {
        index = ctrl.findContact(ctrl.secondaryContacts, item.id).index;
      } else if (item.index !== undefined) {
        index = item.index;
      }
      if (index > -1) {
        ctrl.editModal = $uibModal.open({
          templateUrl: 'views/application/views/partners/create/modals/ManageSecondaryContactModal.tpl.html',
          size: 'lg',
          controller: 'ManageSecondaryContactModalController',
          resolve: {
            ValidateService: function () {
              return ValidateService;
            },
            alertMessage: function () {
              return null;
            },
            organizationId: function () {
              return $state.params.accountId;
            },
            organizationName: function () {
              return $state.params.accountName;
            },
            contact: function () {
              return ctrl.secondaryContacts[index];
            },
            address: function () {
              return null;
            },
          },
        });

        ctrl.editModal.result.then(
          function (contact, address) {
            //update the secondaryContact
            if (contact) {
              ctrl.secondaryContacts[index] = contact;
            }
            $scope.$broadcast('AddressList::Refresh');
            ctrl.refreshOrganization();
          },
          function () {
            $scope.$broadcast('AddressList::Refresh');
          },
        );
      }
    },

    changeAddress: function (type, contactId, address) {
      ctrl.changeAddressModal = $uibModal.open({
        templateUrl: 'views/application/views/partners/create/modals/SelectAddressModal.tpl.html',
        size: 'lg',
        controller: 'SelectAddressModalController',
        resolve: {
          organizationId: function () {
            return $state.params.accountId;
          },
          contactId: function () {
            return contactId;
          },
          address: function () {
            return address;
          },
        },
      });

      ctrl.changeAddressModal.result.then(
        function (address) {
          $scope.$broadcast('AddressDetail::Update', { type: type, contactId: contactId, address: address });
          $scope.$broadcast('AddressList::Refresh');
        },
        function () {
          $scope.$broadcast('AddressList::Refresh');
        },
      );
    },

    createEditAddress: function (address: TODO, type: 'DETAIL_EDIT' | 'LIST_CREATE' | 'LIST_EDIT' = 'DETAIL_EDIT') {
      ctrl.editAddressModal = $uibModal.open({
        templateUrl: 'views/application/views/partners/create/modals/CreateEditAddressModal.tpl.html',
        size: 'md',
        controller: 'CreateEditAddressModalController',
        resolve: {
          organizationId: function () {
            return $state.params.accountId;
          },
          address: function () {
            return address || null;
          },
          preventSave: function () {
            return type === 'DETAIL_EDIT';
          },
        },
      });

      ctrl.editAddressModal.result
        .then((address) => {
          switch (type) {
            case 'DETAIL_EDIT':
            case 'LIST_CREATE':
              $scope.$broadcast('AddressDetail::Update', { address: address });
              break;
            case 'LIST_EDIT':
              // noop
              break;
          }

          ctrl.refreshOrganization();

          // Update visible secondary contacts
          for (let i = 0, ii = ctrl.secondaryContacts.length; i < ii; i++) {
            if ('' + ctrl.secondaryContacts[i].addressId === '' + address.addressId) {
              ctrl.secondaryContacts[i].streetAddress1 = address.streetAddress1;
              ctrl.secondaryContacts[i].streetAddress2 = address.streetAddress2;
              ctrl.secondaryContacts[i].city = address.city;
              ctrl.secondaryContacts[i].state = address.state;
              ctrl.secondaryContacts[i].country = address.country;
              ctrl.secondaryContacts[i].zipCode = address.zipCode;
              break;
            }
          }
        })
        .catch(() => {
          $scope.$broadcast('AddressList::Refresh');
        })
        .finally(() => {
          $scope.$broadcast('AddressList::Refresh');
        });
    },

    createPayment: function (accountId) {
      if (accountId) {
        ctrl.savedPayment.accountId = accountId;
        ApiService.partners.payments
          .create(ctrl.savedPayment)
          .then(ctrl.success.createPayment, ctrl.error.createPayment);
      } else {
        ctrl.notice.showErrorMessages([{ message: 'There was a problem updating the payment policy.' }]);
      }
    },

    savePayment: function (payment) {
      ctrl.savedPayment = payment;
    },

    create: function () {
      const validators = [
        { phone: ctrl.model.company.phoneNumber },
        { len: { value: ctrl.model.company.name } },
        { len: { value: ctrl.model.company.streetAddress1 } },
        { len: { value: ctrl.model.company.city } },
        { len: { value: ctrl.model.company.country } },
        { email: ctrl.model.primaryContact.email },
        { phone: ctrl.model.primaryContact.phoneNumber },
        { name: ctrl.model.primaryContact.firstName },
        { name: ctrl.model.primaryContact.lastName },
      ];

      if (ctrl.validateCountryStates()) {
        validators.push({ len: { value: ctrl.model.company.state } });
      }

      ctrl.isSubmitted = true;

      if (ctrl.isValidCategory()) {
        // Copy category id into model before saving
        ctrl.model.category.id = ctrl.selectedCategory.id;

        if (ValidateService.validate(validators as ACMEValidator[])) {
          ApiService.partners.create(ctrl.model).then(ctrl.success.create, ctrl.error.create);
        } else {
          ctrl.notice.showErrorMessages([{ message: 'Please correct the errors below.' }]);
        }
      } else {
        ctrl.notice.showErrorMessages([{ message: 'Please select an organization category.' }]);
      }
    },

    processSecondaryContacts: function (accountId) {
      let createdPromises: TODO[] = [];

      createdPromises = ctrl.secondaryContacts.map(function (secondaryContact) {
        const props = secondaryContact;

        if (props.id) {
          return ApiService.organizations.contacts.update(props);
        } else {
          props.organizationId = accountId;
          return ApiService.organizations.contacts.create(props);
        }
      });

      createdPromises.concat(
        ctrl.removedSecondaryContacts.map(function (secondaryContact) {
          return ApiService.organizations.contacts.remove({
            contactId: secondaryContact.id,
            organizationId: accountId,
          });
        }),
      );

      $q.all(createdPromises).then(ctrl.success.processSecondaryContacts, ctrl.error.processSecondaryContacts);
    },

    createPrimaryContact: function () {
      const q = $q.defer();
      let primaryContactData = angular.extend({}, ctrl.primaryContactAddress); // Get primary address and append to new contact creation

      // We can only create a new contact if there is a primary address in place.
      if (primaryContactData.id) {
        if (!primaryContactData.addressId) {
          primaryContactData.addressId = primaryContactData.id;
        }
        primaryContactData.id = null;
        delete primaryContactData.id;

        primaryContactData = angular.extend(primaryContactData, ctrl.model.primaryContact);
        if (!primaryContactData.organizationId) {
          primaryContactData.organizationId = ctrl.model.company.id;
        }

        /**
         * NOTE: Create primary contact on POST does not work
         * so we must create a secondary contact and promote it via update
         */

        ApiService.organizations.contacts.create(primaryContactData).then(function (response) {
          const data = response.data.payload;

          data.isPrimary = true;
          data.primary = true;

          ApiService.organizations.contacts.update(data).then(
            function (response) {
              q.resolve(response);
            },
            function (response) {
              q.reject(response);
            },
          );
        });
      } else {
        $timeout(function () {
          q.reject({
            data: {
              error:
                'No primary address exists. Create or Edit an address and make it the primary address for this organization.',
            },
          });
        }, 10);
      }

      return q.promise;
    },

    validateCountryStates: function () {
      return (
        ctrl.model.company.country &&
        (ctrl.model.company.country === 'Canada' || ctrl.model.company.country === 'United States')
      );
    },

    update: function () {
      //update is in 4 steps:
      // 1. update account (company) info
      // 2. update account user info (primary contact)
      // 3. update account payment info
      // 4. update category relation
      // 5. update account notes

      const primaryContactData = {};
      const accountUpdatePromises: TODO[] = [];
      const validators = [
        { phone: ctrl.model.company.phoneNumber },
        { len: { value: ctrl.model.company.name, description: 'Company Name' } },
        { len: { value: ctrl.model.company.streetAddress1, description: 'Street address' } },
        { len: { value: ctrl.model.company.city, description: 'City' } },
        { len: { value: ctrl.model.company.country, description: 'Country' } },
        { email: ctrl.model.primaryContact ? ctrl.model.primaryContact.email : '' },
        { phone: ctrl.model.primaryContact ? ctrl.model.primaryContact.phoneNumber : '' },
        { name: ctrl.model.primaryContact ? ctrl.model.primaryContact.firstName : '' },
        { name: ctrl.model.primaryContact ? ctrl.model.primaryContact.lastName : '' },
      ];

      if (ctrl.validateCountryStates()) {
        validators.push({ len: { value: ctrl.model.company.state, description: 'State' } });
      }

      ctrl.isSubmitted = true;

      if (ctrl.isValidCategory()) {
        if (ValidateService.validate(validators)) {
          accountUpdatePromises.push(ApiService.partners.update(ctrl.model));

          if (ctrl.model.primaryContact && !ctrl.model.primaryContact.accountId) {
            ctrl.model.primaryContact.accountId = Number(ctrl.model.company.id);
          }

          if (ctrl.model.primaryContact && ctrl.model.primaryContact.id) {
            accountUpdatePromises.push(ApiService.partners.user.update(ctrl.model.primaryContact));
          } else {
            accountUpdatePromises.push(ctrl.createPrimaryContact());
          }

          // if payment is changed, update payment
          if (ctrl.savedPayment.accountId) {
            accountUpdatePromises.push(ApiService.partners.payments.update(ctrl.savedPayment));
          }

          if (ctrl.model.accountCategoryRelation) {
            accountUpdatePromises.push(
              ApiService.partners.categories.reassign({
                id: ctrl.model.accountCategoryRelation.id,
                accountId: ctrl.model.accountCategoryRelation.accountId,
                categoryId: ctrl.selectedCategory.id,
              }),
            );
          } else {
            accountUpdatePromises.push(
              ApiService.partners.categories.assign({
                accountId: ctrl.model.company.id!,
                categoryId: ctrl.selectedCategory.id,
              }),
            );
          }

          accountUpdatePromises.push(
            ApiService.partners.notes.update({
              id: ctrl.model.requests[0].requestId,
              notes: ctrl.notes,
            }),
          );

          $q.all(accountUpdatePromises).then(ctrl.success.update, ctrl.error.update);
        } else {
          let msg = 'Please correct the errors below. Organization primary address and primary contact are required.';

          // check for non-input fields errors such as address city, state and country etc
          const addressErrors = ValidateService.errors.filter(function (error) {
            return error.payload && error.payload.len && error.payload.len.description;
          });

          if (addressErrors.length > 0) {
            //check for input field errors
            if (addressErrors.length === ValidateService.errors.length) {
              msg = '';
            } else {
              msg += ' ';
            }

            msg += addressErrors
              .map(function (error) {
                return error.payload.len.description;
              })
              .join(', ');

            msg += addressErrors.length === 1 ? ' is required.' : ' are required.';
          }

          ctrl.notice.showErrorMessages([{ message: msg }]);
        }
      } else {
        ctrl.notice.showErrorMessages([{ message: 'Please select an organization category.' }]);
      }
    },

    complete: function () {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();

      ctrl.isSubmitting = true;
      ctrl.isSubmitted = false;
      // Make sure payment data gets copied before ajax request is sent to create account
      $scope.$broadcast('PaymentOptions::save');
      if (ctrl.isEditEnabled) {
        ctrl.update();
      } else {
        ctrl.create();
      }
    },

    cancel: function () {
      if (ctrl.isEditEnabled) {
        $state.go('application.partners.detail', { id: ctrl.model.company.id });
      } else {
        $state.go('application.partners.list.default');
      }
    },

    findAccountCategory: function (name) {
      let r = false as TODO;

      for (let i = 0, ii = ctrl.categories.length; i < ii; i++) {
        if (name === ctrl.categories[i].name) {
          r = {
            index: i,
            category: ctrl.categories[i],
          };
          break;
        }
      }

      return r;
    },

    unmarshalPayment: function (paymentObj) {
      const deposit = paymentObj.desposit || { daysBeforeEvent: 0, minAmount: 0, percent: 0 };
      const payment = {
        id: paymentObj.id,
        type: paymentObj.type,
        accountId: paymentObj.accountId,
        uniqueVoucherNumbers: paymentObj.uniqueVoucherNumbers,
        ticketDelivery: paymentObj.ticketDelivery,
        taxExempt: paymentObj.taxExempt,
        balanceDueDays: paymentObj.balanceDue ? paymentObj.balanceDue.days : 0,
        depositDueDays: deposit.daysBeforeEvent || 0,
        depositMinimumAmount: deposit.minAmount || 0,
        depositMinimumPercent: deposit.percent || 0,
      };
      return payment;
    },

    refreshSecondaryContactList: function () {
      ctrl.secondaryContactsGridDefinition.isLoaded = true;
      $timeout(function () {
        $scope.$broadcast('DataGrid::ResizeGrid', {
          name: ctrl.secondaryContactsGridDefinition.options.gridName,
          datasetLength: ctrl.secondaryContacts.length,
          totalItems: ctrl.secondaryContacts.length,
        });
      }, 10);
    },

    success: {
      init: function (response) {
        ctrl.model = response.data.payload;
        ctrl.company = ctrl.model.company;
        ctrl.payment.accountId = String(ctrl.model.company.id);
        ctrl.notes = ctrl.model.requests[0] ? ctrl.model.requests[0].posNotes : '';
        if (ctrl.model.accountCategoryRelation) {
          ctrl.selectedCategory = ctrl.findAccountCategory(ctrl.model.accountCategoryRelation.categoryName).category;
        }
        $scope.$broadcast('AddressDetail::Update', {
          type: 'org',
          contactId: ctrl.model.company.id,
          address: ctrl.model.company,
        });
        if (ctrl.model.primaryContact) {
          $scope.$broadcast('AddressDetail::Update', {
            type: 'contact',
            contactId: ctrl.model.primaryContact.id,
            address: ctrl.model.primaryContact,
          });
        }
      },

      getAccountPayment: function (response) {
        ctrl.payment = ctrl.unmarshalPayment(response.data.payload);
      },

      getAccountContacts: function (response) {
        ctrl.secondaryContacts = ctrl.filterContacts(response.data.payload.list, false);
        ctrl.refreshSecondaryContactList();
      },

      create: function (response) {
        // When account has been created apply the payment policy to the account
        // Since we copied the result of the payment directive before the request was sent
        // It should be ready for us.
        // Apply the payment policy to the new partner account
        ctrl.model.company.id = response.data.payload.company.id;
        ctrl.isEditEnabled = true;
        ctrl.createPayment(response.data.payload.company.id);
      },
      createPayment: function (response) {
        // create secondary contacts for this account
        ctrl.processSecondaryContacts(ctrl.model.company.id);
      },
      processSecondaryContacts: function (response) {
        ctrl.isSubmitted = true;
        ctrl.isSubmitting = false;
        $state.go('application.partners.detail', { id: ctrl.model.company.id });
      },

      update: function (response) {
        ctrl.processSecondaryContacts(ctrl.model.company.id);
      },

      getCategories: function (response) {
        ctrl.categories = response.data.payload.list;
      },
    },

    error: {
      init: function (response) {
        // noop
      },

      create: function (response) {
        ctrl.isSubmitted = true;
        ctrl.isSubmitting = false;
        ctrl.notice.hideSuccessMessages();
        ctrl.notice.showErrorMessages([
          {
            message: response.data.error,
          },
        ]);
      },
      createPayment: function (response) {
        ctrl.isSubmitted = true;
        ctrl.isSubmitting = false;
        ctrl.notice.hideSuccessMessages();
        ctrl.notice.showErrorMessages([
          {
            message: response.data.error,
          },
        ]);
      },

      processSecondaryContacts: function (response) {
        ctrl.isSubmitted = true;
        ctrl.isSubmitting = false;
        ctrl.notice.hideSuccessMessages();
        ctrl.notice.showErrorMessages([
          {
            message: response.data.error,
          },
        ]);
      },

      update: function (response) {
        ctrl.isSubmitted = true;
        ctrl.isSubmitting = false;
        ctrl.notice.hideSuccessMessages();
        ctrl.notice.showErrorMessages([
          {
            message: response.data.error,
          },
        ]);
      },

      getCategories: function (response) {
        // noop
      },
      getAccountPayment: function (response) {
        // noop
      },
      getAccountContacts: function (response) {
        // noop
      },
    },

    // When payment has process from directive continue with completion
    onPaymentUpdate: function (payment) {
      ctrl.savePayment(payment);
    },

    gridDoubleClick: function (item) {
      ctrl.editSecondaryContact(item.entity);
    },

    onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
      ctrl.secondaryContactsGridState.updateGridState(newPage, pageSize);

      if (sortField) {
        ctrl.secondaryContactsGridState.updateGridState(null, null, sortField, null);
      }
      if (sortDirection) {
        ctrl.secondaryContactsGridState.updateGridState(null, null, null, sortDirection);
      }

      ctrl.getAccountContacts($state.params.accountId);
    },

    onDataGridSortChange: function (grid, columns, page) {
      const data = columns[0];
      if (data) {
        ctrl.secondaryContactsGridState.updateGridState(page || null, null, data.field, data.sort.direction);
        ctrl.getAccountContacts($state.params.accountId);
      }
    },

    onAddressDetailChange: function (e, data) {
      ctrl.changeAddress(data.type, data.contactId, data.address);
    },

    onAddressDetailEdit: function (e, data) {
      const type = 'DETAIL_EDIT';
      const address = data && data.address ? data.address : null;
      ctrl.createEditAddress(address, type);
    },

    onAddressListCreate: function (e, data) {
      const type = 'LIST_CREATE';
      const address = data && data.address ? data.address : null;
      ctrl.createEditAddress(address, type);
    },

    onAddressListEdit: function (e, data) {
      const type = 'LIST_EDIT';
      const address = data && data.address ? data.address : null;
      ctrl.createEditAddress(address, type);
    },

    onAddressListPrimaryAddress: function (e, data) {
      ctrl.primaryContactAddress = data.address;
    },
  };

  $scope.partnersEdit = ctrl;
  ctrl.init();
}

export const PartnersEditModule = angular
  .module('acme.view.application.partners.edit.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.validate',
    'acme.common.service.helpers',
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
  ])
  .controller('PartnersEditController', PartnersEditController).name;
